module.exports = __webpack_public_path__ + "static/media/main_large_2.d9115dde.png";